export default "__VITE_ASSET__CcllW_DI__"